import { t } from "i18next";
import { Controller } from "react-hook-form";
import { Input } from "ui";

import { CouponType } from "../../../../constants";
import { RequirementsFieldProps } from "../CouponForm.types";

const RequirementField = ({ couponType, control }: RequirementsFieldProps) => {
  switch (couponType) {
    case CouponType.SharingCoupon:
      return (
        <Controller
          control={control}
          name="numberOfSharedProducts"
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <Input
              value={value || ""}
              onChange={onChange}
              errorMessage={error?.message}
              label={`${t("Number of products to share")}`}
              type="number"
              onlyInteger
              placeholder={"Enter a number"}
            />
          )}
        />
      );
    case CouponType.QuantityResoldCoupon:
      return (
        <Controller
          control={control}
          name="quantityResold"
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <Input
              value={value || ""}
              onChange={onChange}
              errorMessage={error?.message}
              label={`${t("Qty of Products Resold")}`}
              type="number"
              onlyInteger
              placeholder={"Enter a number"}
            />
          )}
        />
      );
    case CouponType.AmountResoldCoupon:
      return (
        <Controller
          control={control}
          name="amountResold"
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <Input
              value={value || ""}
              onChange={onChange}
              errorMessage={error?.message}
              label={`${t("Value Resold (FCFA)")}`}
              type="number"
              onlyInteger
              placeholder={"Enter a number"}
            />
          )}
        />
      );
    case CouponType.OrdersResoldCoupon:
      return (
        <Controller
          control={control}
          name="ordersResold"
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <Input
              value={value || ""}
              onChange={onChange}
              errorMessage={error?.message}
              label={`${t("Qty of Orders Resold")}`}
              type="number"
              onlyInteger
              placeholder={"Enter a number"}
            />
          )}
        />
      );
    case CouponType.SpendAndSaveCoupon:
      return (
        <Controller
          control={control}
          name="cartAmount"
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <Input
              value={value || ""}
              onChange={onChange}
              errorMessage={error?.message}
              label={`${t("Cart Value")} (FCFA)`}
              type="number"
              onlyInteger
              placeholder={"Enter a cart value"}
            />
          )}
        />
      );
    default:
      return null;
  }
};

export default RequirementField;
